module.exports = __webpack_public_path__ + "static/banner-update-data-co-MB-6c5eae73b60c9329b987c939bce12237.jpg";